interface PracticeNameCellProps {
    practiceName: string;
    practiceDoctorName?: string | null;
}

// Name-over-doctor pairing shared by the practice-scoped billing tables
// (charges, invoices, one-time discounts, purchase orders).
export function PracticeNameCell({ practiceName, practiceDoctorName }: PracticeNameCellProps) {
    return (
        <>
            <span className="block text-sm font-medium text-gray-800 truncate" title={practiceName}>
                {practiceName}
            </span>
            {practiceDoctorName && (
                <span
                    className="block text-xs text-gray-400 truncate"
                    title={`Dr. ${practiceDoctorName}`}
                >
                    Dr. {practiceDoctorName}
                </span>
            )}
        </>
    );
}
